import { Listbox, Transition } from "@headlessui/react";
import { SelectorIcon } from "@heroicons/react/solid";
import { useEffect, useState } from "react";

const MultiSelect = ({
  options,
  selectedOptions,
  setSelectedOptions,
  title,
  containerClass,
  footerComponent,
  openHandler = false,
  setOpenHandler,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tempTags, setTempTags] = useState([]);

  useEffect(() => {
    if (isOpen || (openHandler === true && setOpenHandler !== undefined)) {
      setTempTags(selectedOptions);
    }
  }, [selectedOptions, openHandler]);

  function handleOptionSelect(option) {
    setTempTags((prev) => {
      if (prev.includes(option)) {
        // If the option is already selected, remove it from the list
        return prev.filter((o) => o !== option);
      } else {
        // If the option is not selected, add it to the end of the list
        const newOptions = [...prev, option];

        return newOptions;
      }
    });
  }

  return (
    <Listbox value={tempTags} onChange={setTempTags} multiple>
      {({ open }) => (
        <>
          <div className={`relative ${containerClass}`}>
            <Listbox.Button
              className={`relative w-full !border bg-[#F4F4F4] !border-[#E6E6E6] py-2 pl-3 pr-10 text-left rounded cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 ${
                open ? "rounded-t-md !py-3" : "rounded !py-3"
              }`}
              onClick={() => {
                if (setOpenHandler !== undefined) {
                  setOpenHandler?.(!openHandler);
                  return;
                }

                setSelectedOptions(tempTags);
                setIsOpen(!isOpen);
              }}
            >
              <span className="block truncate text-sm  pr-3 opacity-70">
                {title}
              </span>
              <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <SelectorIcon
                  className="w-5 h-5 text-gray-400"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>
            <Transition
              show={openHandler || isOpen}
              enter="transition ease-out duration-100 transform"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100 z-[100] relative"
              leave="transition ease-in duration-75 transform"
              leaveFrom="opacity-100 scale-100 z-[100] relative"
              leaveTo="opacity-0 scale-95"
              className={"relative z-[100]"}
            >
              <div className="z-[100] relative">
                <Listbox.Options
                  static
                  className="absolute z-[60] w-full mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                >
                  {options?.map((option) => (
                    <Listbox.Option
                      key={option}
                      className={({ active, selected }) =>
                        `${
                          active ? "text-black bg-[#f1f1f1]" : "text-gray-900"
                        } ${
                          selected ? "font-medium" : "font-normal"
                        } py-2 px-4 cursor-default select-none relative`
                      }
                      value={option}
                      onClick={() => handleOptionSelect(option)}
                    >
                      {({ selected }) => (
                        <div className="items-center gap-4 flex ">
                          <input type="checkbox" checked={selected} />
                          <span
                            className={`${
                              selected ? "font-semibold" : "font-normal"
                            } block truncate`}
                          >
                            {option}
                          </span>
                        </div>
                      )}
                    </Listbox.Option>
                  ))}

                  <div className="sticky bottom-0 bg-white z-10 inset-x-0">
                    {footerComponent && footerComponent?.(tempTags)}
                  </div>
                </Listbox.Options>
              </div>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
};

export default MultiSelect;
